import React from "react";

export function ErrorState(): React.JSX.Element {
  return (
    <div className="ml-6">
      <p>Er is iets fout gegaan!</p>
    </div>
  );
}
